import { createSlice } from '@reduxjs/toolkit';

type DaasAuthState = {
  daasToken: string | null;
  daasTokenExpiry: number | null;
};

export const INITIAL_DAAS_AUTH_STATE: DaasAuthState = {
  daasToken: null,
  daasTokenExpiry: null,
};

const DaasAuthSlice = createSlice({
  name: 'daasAuth',
  initialState: INITIAL_DAAS_AUTH_STATE,
  reducers: {
    setDaasToken: (state, action) => {
      state.daasToken = action.payload;
    },
    setDaasTokenExpiry: (state, action) => {
      state.daasTokenExpiry = action.payload;
    },
  },
});

export const { setDaasToken, setDaasTokenExpiry } = DaasAuthSlice.actions;

export default DaasAuthSlice.reducer;
